import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalInvoiceDeleteProps {}

const ModalInvoiceDelete = ({}: ModalInvoiceDeleteProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    invoice: { setInvoice },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteInvoices');
  const onClose = () => {
    closeSingleModal('deleteInvoices');
    setInvoice('selected.invoice', -1);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Remover invoice"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Invoice.Delete />
    </Modal>
  );
};

export default ModalInvoiceDelete;
